import React from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  AccordionToggleData,
} from "@fluentui/react-components";
import { ChevronUp16Regular, QuestionCircle16Regular } from "@fluentui/react-icons";
import { useSuggestedRedlinesStyles } from "@/components/suggested-redlines/styles";
import { useRedlines } from "@/hooks/use-redlines";

interface RedlineAppliedProps {
  pieceId: string;
  paragraphId: string;
  openItems: Record<string, boolean>;
  handleToggle: (data: AccordionToggleData) => void;
  getAppliedRedlineById: (
    paragraphId: string,
    pieceId: string
  ) => ReturnType<typeof useRedlines>["appliedRedlines"][string][number]["pieces"][number];
}

export const RedlineApplied = ({
  pieceId,
  openItems,
  handleToggle,
  getAppliedRedlineById,
  paragraphId,
}: RedlineAppliedProps) => {
  const styles = useSuggestedRedlinesStyles();
  const appliedRedline = getAppliedRedlineById(paragraphId, pieceId);
  return (
    <div className={styles.redlineAppliedContainer}>
      <div className={styles.redlineSentence}>
        Redline {["add", "replace"].includes(appliedRedline?.type) ? "applied" : "removed"}.
      </div>
      <Accordion openItems={openItems[pieceId] ? [pieceId] : []} collapsible onToggle={(_, data) => handleToggle(data)}>
        <AccordionItem value={pieceId}>
          <AccordionPanel>
            <span>{appliedRedline?.summary}</span>
          </AccordionPanel>
          <AccordionHeader
            style={{ position: "absolute" }}
            expandIcon={openItems[pieceId] ? <ChevronUp16Regular /> : <QuestionCircle16Regular />}
          >
            Summary
          </AccordionHeader>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
